import React from "react";
import IcMapFlag from "./searchIcons/IcMapFlag";
import IcMapPoi000 from "./searchIcons/IcMapPoi000";
import IcMapPoi002 from "./searchIcons/IcMapPoi002";
import IcMapPoi003 from "./searchIcons/IcMapPoi003";
import IcMapPoi004 from "./searchIcons/IcMapPoi004";
import IcMapPoi005 from "./searchIcons/IcMapPoi005";
import IcMapPoi006 from "./searchIcons/IcMapPoi006";
import IcMapPoi007 from "./searchIcons/IcMapPoi007";
import IcMapPoi008 from "./searchIcons/IcMapPoi008";
import IcMapPoi009 from "./searchIcons/IcMapPoi009";
import IcMapPoi011 from "./searchIcons/IcMapPoi011";
import IcMapPoi012 from "./searchIcons/IcMapPoi012";
import IcMapPoi013 from "./searchIcons/IcMapPoi013";
import IcMapPoi015 from "./searchIcons/IcMapPoi015";
import IcMapPoi016 from "./searchIcons/IcMapPoi016";
import IcMapPoi017 from "./searchIcons/IcMapPoi017";
import IcMapPoi018 from "./searchIcons/IcMapPoi018";
import IcMapPoi019 from "./searchIcons/IcMapPoi019";
import IcMapPoi020 from "./searchIcons/IcMapPoi020";
import IcMapPoi021 from "./searchIcons/IcMapPoi021";
import IcMapPoi022 from "./searchIcons/IcMapPoi022";
import IcMapPoi023 from "./searchIcons/IcMapPoi023";
import IcMapPoi024 from "./searchIcons/IcMapPoi024";
import IcMapPoi025 from "./searchIcons/IcMapPoi025";
import IcMapPoi027 from "./searchIcons/IcMapPoi027";
import IcMapPoi028 from "./searchIcons/IcMapPoi028";
import IcMapPoi029 from "./searchIcons/IcMapPoi029";
import IcMapPoi030 from "./searchIcons/IcMapPoi030";
import IcMapPoi031 from "./searchIcons/IcMapPoi031";
import IcMapPoi032 from "./searchIcons/IcMapPoi032";
import IcMapPoi033 from "./searchIcons/IcMapPoi033";
import IcMapPoi034 from "./searchIcons/IcMapPoi034";
import IcMapPoi035 from "./searchIcons/IcMapPoi035";
import IcMapPoi038 from "./searchIcons/IcMapPoi038";
import IcMapPoi039 from "./searchIcons/IcMapPoi039";
import IcMapPoi040 from "./searchIcons/IcMapPoi040";
import IcMapPoi041 from "./searchIcons/IcMapPoi041";
import IcMapPoi042 from "./searchIcons/IcMapPoi042";
import IcMapPoi043 from "./searchIcons/IcMapPoi043";
import IcMapPoi044 from "./searchIcons/IcMapPoi044";
import IcMapPoi045 from "./searchIcons/IcMapPoi045";
import IcMapPoi046 from "./searchIcons/IcMapPoi046";
import IcMapPoi047 from "./searchIcons/IcMapPoi047";
import IcMapPoi048 from "./searchIcons/IcMapPoi048";
import IcMapPoi049 from "./searchIcons/IcMapPoi049";
import IcMapPoi050 from "./searchIcons/IcMapPoi050";
import IcMapPoi051 from "./searchIcons/IcMapPoi051";
import IcMapPoi052 from "./searchIcons/IcMapPoi052";
import IcMapPoi053 from "./searchIcons/IcMapPoi053";
import IcMapPoi054 from "./searchIcons/IcMapPoi054";
import IcMapPoi055 from "./searchIcons/IcMapPoi055";
import IcMapPoi057 from "./searchIcons/IcMapPoi057";
import IcMapPoi058 from "./searchIcons/IcMapPoi058";
import IcMapPoi059 from "./searchIcons/IcMapPoi059";
import IcMapPoi061 from "./searchIcons/IcMapPoi061";
import IcMapPoi062 from "./searchIcons/IcMapPoi062";
import IcMapPoi067 from "./searchIcons/IcMapPoi067";
import IcMapPoi068 from "./searchIcons/IcMapPoi068";
import IcMapPoi069 from "./searchIcons/IcMapPoi069";
import IcMapPoi070 from "./searchIcons/IcMapPoi070";
import IcMapPoi071 from "./searchIcons/IcMapPoi071";
import IcMapPoi073 from "./searchIcons/IcMapPoi073";
import IcMapPoi075 from "./searchIcons/IcMapPoi075";
import IcMapPoi076 from "./searchIcons/IcMapPoi076";
import IcMapPoi077 from "./searchIcons/IcMapPoi077";
import IcMapPoi081 from "./searchIcons/IcMapPoi081";
import IcMapPoi094 from "./searchIcons/IcMapPoi094";
import IcMapPoi095 from "./searchIcons/IcMapPoi095";
import IcMapPoi096 from "./searchIcons/IcMapPoi096";
import IcMapPoi097 from "./searchIcons/IcMapPoi097";
import IcMapPoi098 from "./searchIcons/IcMapPoi098";
import IcMapPoi099 from "./searchIcons/IcMapPoi099";
import IcMapPoi100 from "./searchIcons/IcMapPoi100";
import IcMapPoi101 from "./searchIcons/IcMapPoi101";
import IcMapPoi102 from "./searchIcons/IcMapPoi102";
import IcMapPoi104 from "./searchIcons/IcMapPoi104";
import IcMapPoi105 from "./searchIcons/IcMapPoi105";
import IcMapPoi106 from "./searchIcons/IcMapPoi106";
import IcMapPoi107 from "./searchIcons/IcMapPoi107";
import IcMapPoi108 from "./searchIcons/IcMapPoi108";
import IcMapPoi110 from "./searchIcons/IcMapPoi110";
import IcMapPoi111 from "./searchIcons/IcMapPoi111";
import IcMapPoi113 from "./searchIcons/IcMapPoi113";
import IcMapPoi115 from "./searchIcons/IcMapPoi115";
import IcMapPoi116 from "./searchIcons/IcMapPoi116";
import IcMapPoi117 from "./searchIcons/IcMapPoi117";
import IcMapPoi118 from "./searchIcons/IcMapPoi118";
import IcMapPoi120 from "./searchIcons/IcMapPoi120";
import IcMapPoi122 from "./searchIcons/IcMapPoi122";
import IcMapPoi123 from "./searchIcons/IcMapPoi123";
import IcMapPoi124 from "./searchIcons/IcMapPoi124";
import IcMapPoi125 from "./searchIcons/IcMapPoi125";
import IcMapPoi126 from "./searchIcons/IcMapPoi126";
import IcMapPoi127 from "./searchIcons/IcMapPoi127";
import IcMapPoi128 from "./searchIcons/IcMapPoi128";
import IcMapPoi129 from "./searchIcons/IcMapPoi129";
import IcMapPoi130 from "./searchIcons/IcMapPoi130";
import IcMapPoi131 from "./searchIcons/IcMapPoi131";
import IcMapPoi132 from "./searchIcons/IcMapPoi132";
import IcMapPoi133 from "./searchIcons/IcMapPoi133";
import IcMapPoi134 from "./searchIcons/IcMapPoi134";
import IcMapJunction from "./searchIcons/IcMapJunction";

export function SearchItemIcon({ classifications }: { classifications: string[] }) {
  const icon = getIcon(classifications);

  return <div className="SearchBoxIcon">{icon}</div>;
}

const getIcon = (classifications: any[]) => {
  const category = classifications.find(cs => availableIcons[cs.code] !== undefined) ?? {
    code: "FALLBACK"
  };

  return availableIcons[category.code];
};

const availableIcons = {
  FALLBACK: <IcMapFlag />,
  ACCESS_GATEWAY: <IcMapPoi110 />,
  ADMINISTRATIVE_DIVISION: <IcMapPoi133 />,
  ADVENTURE_SPORTS_VENUE: <IcMapPoi122 />,
  AGRICULTURE: <IcMapPoi107 />,
  AIRPORT: <IcMapPoi007 />,
  AMUSEMENT_PARK: <IcMapPoi051 />,
  AUTOMOTIVE_DEALER: <IcMapPoi008 />,
  BANK: <IcMapPoi077 />,
  BEACH: <IcMapPoi043 />,
  BUILDING_POINT: <IcMapPoi132 />,
  BUSINESS_PARK: <IcMapPoi102 />,
  CAFE_PUB: <IcMapPoi120 />,
  CAMPING_GROUND: <IcMapPoi058 />,
  CAR_WASH: <IcMapPoi067 />,
  CASH_DISPENSER: <IcMapPoi042 />,
  CASINO: <IcMapPoi009 />,
  CINEMA: <IcMapPoi011 />,
  CITY_CENTER: <IcMapPoi012 />,
  CLUB_ASSOCIATION: <IcMapPoi131 />,
  COLLEGE_UNIVERSITY: <IcMapPoi041 />,
  COMMERCIAL_BUILDING: <IcMapPoi098 />,
  COMMUNITY_CENTER: <IcMapPoi081 />,
  COMPANY: <IcMapPoi013 />,
  COURTHOUSE: <IcMapPoi015 />,
  CULTURAL_CENTER: <IcMapPoi016 />,
  DENTIST: <IcMapPoi048 />,
  DEPARTMENT_STORE: <IcMapPoi104 />,
  DOCTOR: <IcMapPoi047 />,
  ELECTRIC_VEHICLE_STATION: <IcMapPoi073 />,
  EMBASSY: <IcMapPoi040 />,
  EMERGENCY_MEDICAL_SERVICE: <IcMapPoi115 />,
  ENTERTAINMENT: <IcMapPoi035 />,
  EXCHANGE: <IcMapPoi096 />,
  EXHIBITION_CONVENTION_CENTER: <IcMapPoi017 />,
  FERRY_TERMINAL: <IcMapPoi018 />,
  FIRE_STATION_BRIGADE: <IcMapPoi068 />,
  FRONTIER_CROSSING: <IcMapPoi019 />,
  FUEL_FACILITIES: <IcMapPoi004 />,
  GEOGRAPHIC_FEATURE: <IcMapPoi127 />,
  GOLF_COURSE: <IcMapPoi020 />,
  GOVERNMENT_OFFICE: <IcMapPoi000 />,
  HEALTH_CARE_SERVICE: <IcMapPoi116 />,
  HELIPAD_HELICOPTER_LANDING: <IcMapPoi123 />,
  HOLIDAY_RENTAL: <IcMapPoi130 />,
  HOSPITAL_POLYCLINIC: <IcMapPoi021 />,
  HOTEL_MOTEL: <IcMapPoi022 />,
  ICE_SKATING_RINK: <IcMapPoi044 />,
  IMPORTANT_TOURIST_ATTRACTION: <IcMapPoi023 />,
  INDUSTRIAL_BUILDING: <IcMapPoi095 />,
  LEISURE_CENTER: <IcMapPoi061 />,
  LIBRARY: <IcMapPoi052 />,
  MANUFACTURING_FACILITY: <IcMapPoi099 />,
  MARINA: <IcMapPoi062 />,
  MARKET: <IcMapPoi118 />,
  MEDIA_FACILITY: <IcMapPoi101 />,
  MILITARY_INSTALLATION: <IcMapPoi106 />,
  MOTORING_ORGANIZATION_OFFICE: <IcMapPoi076 />,
  MOUNTAIN_PASS: <IcMapPoi024 />,
  MUSEUM: <IcMapPoi025 />,
  NATIVE_RESERVATION: <IcMapPoi125 />,
  NIGHTLIFE: <IcMapPoi050 />,
  NON_GOVERNMENTAL_ORGANIZATION: <IcMapPoi134 />,
  OPEN_PARKING_AREA: <IcMapPoi002 />,
  OTHER: <IcMapFlag />,
  PARKING_GARAGE: <IcMapPoi003 />,
  PARK_RECREATION_AREA: <IcMapPoi059 />,
  PETROL_STATION: <IcMapPoi004 />,
  PHARMACY: <IcMapPoi054 />,
  PLACE_OF_WORSHIP: <IcMapPoi027 />,
  POLICE_STATION: <IcMapPoi039 />,
  PORT_WAREHOUSE_FACILITY: <IcMapPoi105 />,
  POST_OFFICE: <IcMapPoi028 />,
  PRIMARY_RESOURCE_UTILITY: <IcMapPoi108 />,
  PRISON_CORRECTIONAL_FACILITY: <IcMapPoi094 />,
  PUBLIC_AMENITY: <IcMapPoi097 />,
  PUBLIC_TRANSPORT_STOP: <IcMapPoi069 />,
  RAILWAY_STATION: <IcMapPoi005 />,
  RENT_A_CAR_FACILITY: <IcMapPoi029 />,
  RENT_A_CAR_PARKING: <IcMapPoi030 />,
  REPAIR_FACILITY: <IcMapPoi053 />,
  RESEARCH_FACILITY: <IcMapPoi100 />,
  RESIDENTIAL_ACCOMMODATION: <IcMapPoi075 />,
  RESTAURANT: <IcMapPoi031 />,
  RESTAURANT_AREA: <IcMapPoi031 />,
  REST_AREA: <IcMapPoi006 />,
  SCENIC_PANORAMIC_VIEW: <IcMapPoi055 />,
  SCHOOL: <IcMapPoi070 />,
  SHOP: <IcMapPoi032 />,
  SHOPPING_CENTER: <IcMapPoi033 />,
  SPORTS_CENTER: <IcMapPoi038 />,
  STADIUM: <IcMapPoi034 />,
  SWIMMING_POOL: <IcMapPoi046 />,
  TENNIS_COURT: <IcMapPoi045 />,
  THEATER: <IcMapPoi035 />,
  TOURIST_INFORMATION_OFFICE: <IcMapPoi023 />,
  TRAFFIC_LIGHT: <IcMapPoi129 />,
  TRAFFIC_SERVICE_CENTER: <IcMapPoi126 />,
  TRAFFIC_SIGN: <IcMapPoi128 />,
  TRAIL_SYSTEM: <IcMapPoi124 />,
  TRANSPORT_AUTHORITY_VEHICLE_REGISTRATION: <IcMapPoi113 />,
  TRUCK_STOP: <IcMapPoi071 />,
  VETERINARIAN: <IcMapPoi049 />,
  WATER_SPORT: <IcMapPoi046 />,
  WEIGH_STATION: <IcMapPoi111 />,
  WELFARE_ORGANIZATION: <IcMapPoi117 />,
  WINERY: <IcMapPoi057 />,
  ZOOS_ARBORETA_BOTANICAL_GARDEN: <IcMapPoi003 />,
  JUNCTION: <IcMapJunction />
};
